import { Typography, AppBar } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {Facebook, Twitter, LinkedIn, GitHub} from '@mui/icons-material';

const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#1976d2',
      },
    },
});

const Footer = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <ThemeProvider theme={darkTheme}>
                    <AppBar position="static" color="primary" sx={{ py: 5 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '300px', marginLeft: '530px', marginBottom: '50px' }}>
                            <Facebook onClick={event =>  window.location.href='https://www.facebook.com/anup.chakroborty.9889'} />
                            <Twitter onClick={event =>  window.location.href='https://twitter.com/AnupAtu'} />
                            <LinkedIn onClick={event =>  window.location.href=' https://www.linkedin.com/in/anup-chakraborty-929240154'} />
                            <GitHub onClick={event =>  window.location.href='https://github.com/anupchakraborty'}/>
                        </Box>
                        <Typography variant="body1" gutterBottom>
                            Copy Right by Anup Chakraborty 2021
                        </Typography>
                    </AppBar>
                </ThemeProvider>
            </Box>
        </>
    );
};

export default Footer;